import { CALL_API } from "admin/middlewares/api";

export const USER_UC_REPORTS_GET_REQUEST = "USER_UC_REPORTS_GET_REQUEST";
export const USER_UC_REPORTS_GET_SUCCESS = "USER_UC_REPORTS_GET_SUCCESS";
export const USER_UC_REPORTS_GET_ERROR = "USER_UC_REPORTS_GET_ERROR";

export function get_uc_reports(accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/uc/byaccountid?accountId=" + accountId,
      authenticatedRequest: true,
      correlation: { accountId },
      types: [
        USER_UC_REPORTS_GET_REQUEST,
        USER_UC_REPORTS_GET_SUCCESS,
        USER_UC_REPORTS_GET_ERROR,
      ],
    },
  };
}
